
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep5 {
  description: string;
  hasConflict: string;
  investigatorId: string;
  coiDescription: string;
}

export default defineComponent({
  name: "step-5",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
  },
  setup() {
    const store = useStore();

    const step5 = ref<IStep5>({
      description: "",
      hasConflict: "0",
      investigatorId: "",
      coiDescription: "",
    });

    const listDropDownSections = [
      {
        title: "Conflict of Interest",
        descriptions: [
          {
            description:
              "A conflict of interest for a principal investigator in research occurs when they have a personal or financial interest that could potentially influence their research or decisions related to the research project. This could include receiving funding or other incentives from a company or organization that has a stake in the outcome of the research, having personal relationships with individuals who could benefit from the research results, or holding patents or intellectual property rights related to the research. Conflict of interest can compromise the integrity and objectivity of the research and undermine public trust in the results. It is important for principal investigators to disclose any potential conflicts of interest and take steps to mitigate their impact on the research.",
          },
        ],
      },
    ];
    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });
    const currentCoInvestigators = computed(() => {
      return store.getters.currentCoInvestigators;
    });

    watchEffect(() => {
      const data = store.getters.currentResearch;
      if (data === null || data.data === undefined) return;
      step5.value.description = data.data.description || "";
      step5.value.hasConflict = data.data.hasConflict ? "1" : "0";
      step5.value.investigatorId = data.data.investigatorId || "";
      step5.value.coiDescription = data.data.coiDescription || "";
    });

    return {
      currentCoInvestigators,
      step5,
      Editor,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
